import { render } from "./basicAccordion.vue?vue&type=template&id=10ad359c"
import script from "./basicAccordion.vue?vue&type=script&lang=js"
export * from "./basicAccordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__